import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseModel, StrictBaseModelPart } from '@dev-stream/utils';
import { BaseComponent } from '@idocs/shared-ui/core';

export class BillingBlockConfig<T = any> extends BaseModel<BillingBlockConfig<T>> {
    GetDefaultValue(): StrictBaseModelPart<BillingBlockConfig<T>, never> {
        return {
            hasButton: true,
        };
    }
    protected BASE_TYPE = BillingBlockConfig;
    title?: string;
    label?: string;
    buttonText?: string;
    hasButton!: boolean;
    showTitleLoader?: boolean;
    data?: T;
}

@Component({
    selector: 'billing-ui-billing-block',
    templateUrl: './billing-block.component.html',
    styleUrls: ['./billing-block.component.scss'],
})
export class BillingBlockComponent extends BaseComponent implements OnInit {
    @Input() config?: BillingBlockConfig<any>;

    @Output() btnClick = new EventEmitter<any>();

    

    ngOnInit(): void {}
}
